module.exports = __webpack_public_path__ + "6a623f8292b7feb0d424ae95786dddd8.png";


//////////////////
// WEBPACK FOOTER
// ../server/public/static/images/moma/nav-light-right@2x.png
// module id = 300
// module chunks = 0 1 2 3 4 5